/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Mic_DeniedInputs */

const en_us2_coach_mic_denied = /** @type {(inputs: Coach_Mic_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allow the microphone in settings`)
};

const pt_br2_coach_mic_denied = /** @type {(inputs: Coach_Mic_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permita o microfone nas configurações`)
};

const es_419_coach_mic_denied = /** @type {(inputs: Coach_Mic_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permite el micrófono en la configuración`)
};

const pt_pt2_coach_mic_denied = /** @type {(inputs: Coach_Mic_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permite o microfone nas definições`)
};

const fr_fr2_coach_mic_denied = /** @type {(inputs: Coach_Mic_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autorise le micro dans les réglages`)
};

const de_de2_coach_mic_denied = /** @type {(inputs: Coach_Mic_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erlaube das Mikrofon in den Einstellungen`)
};

const it_it2_coach_mic_denied = /** @type {(inputs: Coach_Mic_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consenti il microfono nelle impostazioni`)
};

/**
* | output |
* | --- |
* | "Allow the microphone in settings" |
*
* @param {Coach_Mic_DeniedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coach_mic_denied = /** @type {((inputs?: Coach_Mic_DeniedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Mic_DeniedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coach_mic_denied(inputs)
	if (locale === "es-419") return es_419_coach_mic_denied(inputs)
	if (locale === "pt-PT") return pt_pt2_coach_mic_denied(inputs)
	if (locale === "fr-FR") return fr_fr2_coach_mic_denied(inputs)
	if (locale === "de-DE") return de_de2_coach_mic_denied(inputs)
	if (locale === "it-IT") return it_it2_coach_mic_denied(inputs)
	return en_us2_coach_mic_denied(inputs)
});
export { coach_mic_denied as "coach-mic.denied" }